class ExtendableError extends Error {
  constructor(message) {
    super(message)
    this.name = this.constructor.name
    this.stack = (new Error(message)).stack
    // console.error(this.stack)
  }
}

class ApiError extends ExtendableError {
  constructor(message, response) {
    super(message)
    this.response = response
  }
}

class UnauthorizedError extends ApiError {
  constructor(message, response) {
    super(message, response)
    this.name = 'UnauthorizedError'
  }
}

class AuthenticationError extends ApiError {
  constructor(message, response) {
    super(message, response)
    this.name = 'AuthenticationError'
  }
}

class ForbiddenError extends ApiError {
  constructor(message, response) {
    super(message, response)
    this.name = 'ForbiddenError'
  }
}

class InternalServerError extends ApiError {
  constructor(message, response) {
    super(message, response)
    this.name = 'InternalServerError'
  }
}

class ServiceUnavailableError extends ApiError {
  constructor(message, response) {
    super(message, response)
    this.name = 'ServiceUnavailableError'
  }
}

class ResourceNotFoundError extends ApiError {
  constructor(message, response) {
    super(message, response)
    this.name = 'ResourceNotFoundError'
  }
}

class BadRequestError extends ApiError {
  constructor(message, response) {
    super(message, response)
    this.name = 'BadRequestError'
  }
}

class LoginTimedOutError extends ApiError {
  constructor(message, response) {
    super(message, response)
    this.name = 'BadRequestError'
  }
}

class RequestParamsMissingError extends ExtendableError {
  constructor(message, payload) {
    super(message)
    this.payload = payload
    this.name = 'RequestParamsMissingError'
  }
}

export {
  UnauthorizedError,
  AuthenticationError,
  ForbiddenError,
  ResourceNotFoundError,
  InternalServerError,
  ServiceUnavailableError,
  LoginTimedOutError,
  BadRequestError,
  RequestParamsMissingError
}
